import Grid from "@mui/material/Unstable_Grid2";
import { ReleasePost } from "./PostTypes";

export interface PostDetailsProps {
  post: ReleasePost;
}

const PostDetails = (props: PostDetailsProps) => {
  const { post } = props;

  return (
    <Grid xs={12}>

      <Grid container xs={2}>
        Type
      </Grid>
      <Grid container xs={10}>
        { post.mediaKind.kind }
      </Grid>
      <Grid container xs={2}>
        Subtype
      </Grid>
      <Grid container xs={10}>
        { post.mediaKind.subkind }
      </Grid>
      <Grid container xs={2}>
        {
          post.lengthUnit === "pages" ? "Pages" : "Runtime"
        }
      </Grid>
      <Grid container xs={10}>
        {`${ post.length } ${ post.lengthUnit === "pages" ? "" : post.lengthUnit }`}
      </Grid>

    </Grid>
  )
}

export default PostDetails;